import { render, staticRenderFns } from "./CheckWorkStatistic.vue?vue&type=template&id=5704d102&"
import script from "./CheckWorkStatistic.vue?vue&type=script&lang=js&"
export * from "./CheckWorkStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports